import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { confirmForgotPassword, forgotPassword } from "../../Auth/auth-service";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

const ConfirmForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [flag, setFlag] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleConfirmForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await confirmForgotPassword(email, code, newPassword);
      alert(
        "Password reset successful. You can now log in with your new password."
      );
    } catch (error) {
      alert(
        "Error confirming password reset. Please check the code and try again."
      );
      console.error("Confirm Forgot Password Error: ", error);
    } finally {
      navigate("/login");
      setLoading(false);
    }
  };

  const handleOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
      setFlag(true);
    } catch (error) {
      alert(`Sign up failed: ${error}`);
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 2,
        backgroundColor: "#EEEEEE",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            boxShadow: "inset 0 0 50px rgba(0, 0, 0, 0.5)",
            pointerEvents: "none",
          },
        }}
      />
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          mt: 15,
          fontWeight: "bold",
          color: "#222831",
          display: "flex",
          alignItems: "center",
          position: "relative",
          zIndex: 1,
          fontFamily: "Poppins",
        }}
      >
        <CheckCircle sx={{ color: "#00ADB5", marginRight: 1 }} />
        Reset Password
      </Typography>
      <form
        style={{
          maxWidth: "450px",
          width: "100%",
          backgroundColor: "#FFFFFF",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <TextField
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-label="Email"
          placeholder="Email"
          InputProps={{
            readOnly: flag,
          }}
          required
          fullWidth
          margin="normal"
          sx={{
            fontFamily: "Poppins",
            "& .MuiInputBase-root": {
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.2)",
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#00ADB5",
              },
            },
          }}
        />
        {/* <Box sx={{ textAlign: "center", mt: 2 }}>
          <Button
          type="submit"
            variant="contained"
            onClick={handleOtp}
            sx={{
              fontFamily: "Poppins",
              display: flag ? "none" : "",
              backgroundColor: "#00ADB5",
              color: "#FFF",
              "&:hover": {
                backgroundColor: "#007B7F",
              },
              borderRadius: "8px",
              padding: "10px 20px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
            fullWidth
            disabled={flag}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Get Verification Code"
            )}
          </Button>
        </Box> */}
        {flag ? (
          <>
            <TextField
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              aria-label="Confirmation Code"
              placeholder="Confirmation Code"
              required
              fullWidth
              margin="normal"
              sx={{
                fontFamily: "Poppins",
                "& .MuiInputBase-root": {
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.2)",
                },
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#00ADB5",
                  },
                },
              }}
            />
            <TextField
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              aria-label="Password"
              placeholder="Password"
              required
              fullWidth
              margin="normal"
              sx={{
                fontFamily: "Poppins",
                "& .MuiInputBase-root": {
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.2)",
                },
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#00ADB5",
                  },
                },
              }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="inherit" />
                        ) : (
                          <Visibility fontSize="inherit" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        <Box sx={{ textAlign: "center", mt: 2 }}>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  fontFamily: "Poppins",
                  backgroundColor: "#00ADB5",
                  color: "#FFF",
                  "&:hover": {
                    backgroundColor: "#007B7F",
                  },
                  borderRadius: "8px",
                  padding: "10px 20px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                }}
                fullWidth
                onClick={flag?handleConfirmForgotPassword:handleOtp}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  <>
                  {
                    flag?"Reset":"Get Verification Code"
                  }
                  </>
                )}
              </Button>
            </Box>
      </form>
    </Box>
  );
};

export default ConfirmForgotPassword;
